import React, { useEffect, useState } from "react";

// Rotating car images loaded onto the flatbed.
// Add more entries here (e.g., "/car2.png", "/car3.png") — the carousel
// automatically fades between them every 30 seconds.
const CARS = ["/car1.png"];
const ROTATE_MS = 30000;
const FADE_MS = 900;

export default function HeroTruckPhoto({ className = "" }) {
  const [idx, setIdx] = useState(0);

  useEffect(() => {
    if (CARS.length <= 1) return;
    const t = setInterval(() => {
      setIdx((i) => (i + 1) % CARS.length);
    }, ROTATE_MS);
    return () => clearInterval(t);
  }, []);

  return (
    <div
      className={`hero-truck-photo relative w-full ${className}`}
      data-testid="hero-truck-photo"
    >
      {/* Tow truck base */}
      <img
        src="/towtruck.png"
        alt="MR Crusher flatbed tow truck"
        className="relative z-10 w-full h-auto select-none pointer-events-none"
        draggable={false}
      />

      {/* Car(s) layered over the flatbed — cross-fade carousel.
          Flatbed on the tow-truck image sits roughly:
          left ~ 34%   right ~ 3%   top ~ 4%   bottom ~ 34%
          Enlarged box so the car fills the deck naturally (~25% bigger). */}
      <div className="absolute inset-0 z-20 pointer-events-none">
        <div
          className="absolute"
          style={{
            left: "30%",
            right: "3%",
            top: "0%",
            bottom: "25%",
          }}
        >
          {/* Soft ground shadow that sits on the flatbed surface right under
              the car so it looks grounded, not floating. */}
          <div
            aria-hidden="true"
            className="absolute left-[8%] right-[8%] bottom-[-2%] h-3 rounded-full bg-black/45 blur-md"
          />
          {CARS.map((src, i) => (
            <img
              key={src}
              src={src}
              alt={`Damaged car ${i + 1} loaded on flatbed`}
              draggable={false}
              className={`absolute inset-0 w-full h-full object-contain object-bottom transition-opacity ease-in-out ${
                i === idx ? "opacity-100" : "opacity-0"
              }`}
              style={{
                transitionDuration: `${FADE_MS}ms`,
                filter:
                  "drop-shadow(0 14px 10px rgba(0,0,0,0.32)) drop-shadow(0 3px 2px rgba(0,0,0,0.25))",
              }}
              data-testid={`hero-car-${i}`}
            />
          ))}
        </div>
      </div>

      {/* Ground shadow under truck for lift */}
      <div
        className="absolute z-0 left-[6%] right-[6%] bottom-[6%] h-3 bg-black/25 blur-xl rounded-full"
        aria-hidden="true"
      />
    </div>
  );
}
